import { Minus } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from '../icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton icon={Minus} tooltip="Remover" {...props} />
)

export default Component
